import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { startUpdateCheck } from "./update-check";
import { App } from "./App";
import { guardWindowDrops } from "./DropFiles";
import { registerServiceWorker, startOfflineSync } from "./offline";
import "./styles.css";
import "./daily-reports.css";
import "./v3.css";
import "./theme.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

if (import.meta.env.PROD) { startUpdateCheck(); registerServiceWorker(); }
startOfflineSync();
guardWindowDrops();
